export default function removeUndefinedAndNull(array) {
  return array.filter(x => typeof x !== 'undefined' && x !== null);
}